import { DynamicStandaloneAdTemplate } from '@/components/AdTemplate';
import { LabradorComponent } from '@/types/component';

const LabradorAdTemplate: LabradorComponent = ({ data }) => {
  return <DynamicStandaloneAdTemplate pageMeta={data?.meta} />;
};

export default LabradorAdTemplate;
